<template>
    <div class="wrapper">
        <v-head ref="headChild"></v-head>
        <v-sidebar></v-sidebar>
        <div class="content-box" :class="{'content-collapse':collapse}" id="content-box">
            <v-tags></v-tags>


            <div class="content">
                <!-- 缓存标签 -->
                <keep-alive :include="tagsList">
                    <router-view></router-view>
                </keep-alive>

                <el-backtop target=".content"></el-backtop>
            </div>


        </div>



    </div>
</template>
<script>
    import axios from 'axios'; // AJAX封装类

    import vHead from './Header.vue';
    import vSidebar from './Sidebar.vue';
    import vTags from './Tags.vue';
    import bus from './bus';
    import {
        config
    } from '../../utils/config'; //配置
    var _this, notifyClose;
    export default {

        data() {
            return {


                tagsList: [],
                collapse: false,



                socket_relink_num: 0,


                firstlog: true,

                //发送初始化链接参数
                sendData: {
                    ws_mode: '',
                    port: 'admin',
                    platform: 'pc',
                    token: '',
                    hash_key: ''
                    // city_tag: 'CHANGCHUN'
                }


            };
        },
        components: {
            vHead,
            vSidebar,
            vTags
        },

        beforeCreate() {

            // 判断播报开关是否打开
            if (JSON.parse(localStorage.getItem('broadcast_value'))) {

            } else {

                localStorage.setItem('broadcast_value', JSON.stringify({
                    driver_online: true,
                    driver_offline: true,
                    need_driver: true
                }));

            }

            // bus.$emit('Socket');


        },

        created() {

            _this = this;

            bus.$on('collapse', msg => {
                this.collapse = msg;
            });
            // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
            bus.$on('tags', msg => {
                // console.log(msg);
                let arr = [];
                for (let i = 0, len = msg.length; i < len; i++) {
                    msg[i].name && arr.push(msg[i].name);
                }
                this.tagsList = arr;
            });


            // bus.$on('mapIsShow', msg => {

            //     _this.map_show = msg

            // });





            _this.$post(
                '/mine/tokenDetails'
            )
                .then(res => {

                    // 缓存登录信息
                    localStorage.setItem('login', JSON.stringify(res.data));


                    _this.socket();


                }).catch((err) => {

            });


            // 接收连接Socket的通知
            bus.$on('Socket', msg => {

                //接收Socket连接传来的数据
                _this.global.ws.onmessage = function(res) {
                    var resData = JSON.parse(res.data);
                    // console.log(resData);

                    _this.$driverState(resData, JSON.parse(localStorage.getItem('broadcast_value')));

                    if (resData.identification == 'link' && resData.header == 'success') {
                        // 接收到连接成功数据
                        console.log(resData);
                        var data = {
                            'server_status_0': 1,
                            'server_status_1': 1,
                            'server_status_2': 1,
                            'server_status_3': 1,
                            'server_status_4': 1,
                            'server_status_5': 1,
                            'server_status_6': 1,
                            'switch': 0,
                            'status': 88
                        };


                        var sendData = {
                            'ws_mode': 'driverControl',
                            'driver_control_synchronization': JSON.stringify(data)
                        };

                        _this.global.ws.send(JSON.stringify(sendData));
                        _this.$sendPing()
                        // setInterval(() => {
                        //     _this.global.ws.send(JSON.stringify('11'));
                        // }, 10000);


                    } else if (resData.identification == 'link' && resData.header == 'logout') {
                        // 接收token失效

                        _this.firstlog = false;


                    }


                };

            });


            // 接收连接Socket的通知
            bus.$on('appToSocket', msg => {

                //接收Socket连接传来的数据
                _this.global.ws.onmessage = function(res) {
                    var resData = JSON.parse(res.data);
                    // console.log(resData);

                    _this.$driverState(resData, JSON.parse(localStorage.getItem('broadcast_value')));

                    if (resData.identification == 'link' && resData.header == 'success') {
                        // 接收到连接成功数据

                        var data = {
                            'server_status_0': 1,
                            'server_status_1': 1,
                            'server_status_2': 1,
                            'server_status_3': 1,
                            'server_status_4': 1,
                            'server_status_5': 1,
                            'server_status_6': 1,
                            'switch': 0,
                            'status': 88
                        };


                        var sendData = {
                            'ws_mode': 'driverControl',
                            'driver_control_synchronization': JSON.stringify(data)
                        };

                        _this.global.ws.send(JSON.stringify(sendData));
                        _this.$sendPing();

                    } else if (resData.identification == 'link' && resData.header == 'logout') {
                        // 接收token失效

                        _this.firstlog = false;


                    }

                };

            });


            bus.$on('firstlog', msg => {
                console.log('触发了firstlog');
                _this.firstlog = msg;

            });

            bus.$on('logIn', msg => {
                console.log('触发了logIn');




                _this.socket();





            });


        },

        watch: {
            firstlog() {
                if (_this.firstlog && _this.num < 10) {

                    _this.socket();


                } else {

                    // 关闭socket
                    if (_this.global.ws) {
                        _this.global.ws.close();
                    }

                }
            }
        },
        methods: {


            socket() {

                // var token = localStorage.getItem(config.localStorage_token_name);

                // // 哈希值
                // var hash_key = this.$hash_key();
                // _this.sendData.ws_mode = 'link';
                // _this.sendData.token = token;
                // _this.sendData.hash_key = hash_key;


                // 建立Socket连接
                _this.localSocket();


                //接收Socket连接传来的数据
                _this.global.ws.onmessage = function(res) {
                    bus.$emit('Socket');

                    var resData = JSON.parse(res.data);
                    // console.log(resData);

                    _this.$driverState(resData, JSON.parse(localStorage.getItem('broadcast_value')));


                };


            },

            localSocket() {
                if ('WebSocket' in window) {
                    console.log('您的浏览器支持 WebSocket!');


                    console.log(_this.$getSocketUrl());

                    _this.ws = new WebSocket(_this.$getSocketUrl());


                    // console.log(_this.$getSocketUrl());

                    _this.global.setWs(_this.ws);

                    _this.ws.onopen = _this.webSocketOnOpen;

                    _this.ws.onerror = _this.webSocketOnError;


                    _this.ws.onclose = _this.webSocketOnClose;


                } else {
                    // 浏览器不支持 WebSocket
                    console.log('您的浏览器不支持 WebSocket!');
                }
            },

            // 建立连接成功后的状态
            webSocketOnOpen() {

                // // 发送数据
                // _this.global.ws.send(JSON.stringify(_this.sendData));


            },

            // 关闭连接
            webSocketOnClose() {

                console.log('socket已关闭');

                // console.log(_this.firstlog);


                if (_this.firstlog && _this.socket_relink_num < 10) {

                    setTimeout(() => {

                        _this.socket_relink_num += 1;
                        _this.socket();

                    }, 2000);


                } else if (_this.socket_relink_num >= 10) {

                    if (notifyClose) {

                    } else {

                        notifyClose = _this.$notify({

                            message: 'WebSocket链接失败,请刷新浏览器重试',
                            duration: 0,
                            type: 'warning',
                            offset: 80

                        });

                    }

                }


                // console.log('Socket已关闭');


            },

            //连接失败的事件
            webSocketOnError(res) {


            }
        }

    };
</script>
<style>
    .content-box.content-collapse {
        left: 65px !important;
    }

    .content-box {
        left: 260px;
    }

    .el-menu--vertical > .el-menu.el-menu--popup {
        background-color: rgba(0, 0, 0, 0) !important;
        margin: 0;
        box-shadow: none !important;
    }
</style>
